import { DesignClient } from 'api/clients/DesignClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useMutation } from 'react-query'
import { useRootStore } from 'stores/RootStore'
import { DesignActionType } from 'types'

export interface Variables {
  action: DesignActionType
}

export const useCompleteDesignAction = () => {
  const { files, designStore } = useRootStore()
  const file = designStore?.file

  return useMutation<void, Error, Variables>(
    'completeDesignAction',
    async (payload) => {
      if (!file) return

      const completedActions = file.completed_actions || {}

      if (completedActions[payload.action]) {
        return
      }

      const originalCompletedActions = { ...completedActions }
      completedActions[payload.action] = true
      files.updateAttrs(file.id, {
        completed_actions: completedActions,
      })

      const response = await DesignClient.updateDesign(file.id, {
        completed_actions: completedActions,
      })

      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        files.updateAttrs(file.id, {
          completed_actions: originalCompletedActions,
        })
        throw new Error('Failed to update completed actions')
      }
      return
    },
    {},
  )
}
